export const SERVER_URL = process.env.REACT_APP_API_URL;
export const API_URL = `${SERVER_URL}/api/v1`;
